<script setup lang="ts">
defineProps({
  error: {
    type: Object as () => NuxtError,
    default: () => ({ statusCode: 500, message: 'An unexpected error occurred' })
  }
})

const handleError = () => clearError({ redirect: '/' })
</script>

<template>
  <div class="container mx-auto">
    <Logo />
    <div class="flex h-screen flex-col justify-center">
      <div class="mx-auto w-full max-w-4xl">
        <div class="flex">
          <div class="text-3xl font-bold">{{ error?.statusCode }}</div>
          <h1 class="self-center pl-2 text-lg">{{ error?.message }}</h1>
        </div>
        <div class="font-sm mt-5">
          <Button variant="cta" class="cursor-pointer underline" @click="handleError"
            >Back to Homepage</Button
          >
        </div>
      </div>
    </div>
  </div>
</template>
